import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';

export class game5pct extends cDisplay {

  private dropTargtes:string[]

  init(){
    super.init()
    console.log('GAME gamePower')
    var cS:cScene = this.scene as cScene;       
    this.dropTargtes = []; 
    
    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){
        case 'handle_drop':
          var corrct:string[] = ['party_1','party_2','party_3','party_4']
          var ref:cSprite = (this.getByName(b.payload.drag) as cSprite)
          var tg:cSprite  = (this.getByName('parlament') as cSprite)

          if (b.payload.tg && corrct.indexOf(b.payload.drag) !== -1 ){
            ref.visible = false;
            this.dropTargtes.push( b.payload.drag )
            if (this.dropTargtes.length == corrct.length){
              cS.triggerSceneEvent('complete')
            }            
          }else if (b.payload.tg){
            ref.modules.drag.returnToOrigin();  
            cS.triggerSceneEvent('error',{info: '',title:'Stimmt!' })
          }

          console.log(b.payload);
          return;
          if (corrct.indexOf(b.payload.drag) === -1){
            tg.dragitem = tg.dragitem.filter( (c)=>c!==ref )
            setTimeout(()=>{
              ref.modules.drag.returnToOrigin()  
            },2000)
            cS.triggerSceneEvent('error',{info: '',title:'Stimmt!' })
          }else{
            this.dropTargtes.push( b.payload.drag )
            ref.visible = false
            if (this.dropTargtes.length == corrct.length){
              cS.triggerSceneEvent('complete')
            }
          }
          break;
      }
    })
  }

  buildScene(){    
    super.buildScene();
  }



}
